import { render, staticRenderFns } from "./r-help.vue?vue&type=template&id=de19ead2"
import script from "./r-help.vue?vue&type=script&lang=js"
export * from "./r-help.vue?vue&type=script&lang=js"
import style0 from "./r-help.vue?vue&type=style&index=0&id=de19ead2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports